/**
 * Date / time formatting helpers for SIGSAOP.
 * Locale: es-CL · Timezone: America/Santiago
 * Formato preferido para mostrar: DD-MM-AAAA
 */
export const TZ = "America/Santiago";

/** Devuelve la fecha en formato DD-MM-AAAA. Acepta "YYYY-MM-DD" o ISO. */
export function formatDate(input) {
  if (!input) return "—";
  // Si viene "2026-05-18", evitamos crear Date para no tener desfase de zona
  if (typeof input === "string" && /^\d{4}-\d{2}-\d{2}/.test(input)) {
    const [y, m, d] = input.slice(0, 10).split("-");
    return `${d}-${m}-${y}`;
  }
  try {
    const d = new Date(input);
    return new Intl.DateTimeFormat("es-CL", {
      day: "2-digit", month: "2-digit", year: "numeric", timeZone: TZ,
    }).format(d);
  } catch { return String(input); }
}

/** Devuelve fecha + hora DD-MM-AAAA HH:mm en hora Chile. */
export function formatDateTime(input, hora = null) {
  if (!input) return "—";
  const datePart = formatDate(input);
  if (hora) {
    return `${datePart} ${String(hora).slice(0, 5)}`;
  }
  if (typeof input === "string" && input.length > 10) {
    try {
      const d = new Date(input);
      const t = new Intl.DateTimeFormat("es-CL", {
        hour: "2-digit", minute: "2-digit", timeZone: TZ, hour12: false,
      }).format(d);
      return `${datePart} ${t}`;
    } catch { return datePart; }
  }
  return datePart;
}

/** Hora HH:mm (acepta "10:00:00" o "10:00"). */
export function formatTime(t) {
  if (!t) return "";
  return String(t).slice(0, 5);
}

/** "hoy", "ayer", "mañana", "en X días" o "hace X días" relativo. */
export function relativeDays(targetISO) {
  if (!targetISO) return "";
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const target = typeof targetISO === "string"
    ? new Date(targetISO.slice(0, 10) + "T00:00:00")
    : new Date(targetISO);
  const diffDays = Math.round((target - today) / 86400000);
  if (diffDays === 0) return "hoy";
  if (diffDays === 1) return "mañana";
  if (diffDays === -1) return "ayer";
  if (diffDays > 0) return `en ${diffDays} días`;
  return `hace ${-diffDays} días`;
}


/** Formatea un número como CLP: 68000000 -> "$68.000.000". */
export function formatCLP(n) {
  const v = Number(n || 0);
  if (!Number.isFinite(v)) return "$0";
  return `$${v.toLocaleString("es-CL")}`;
}

/** Quita todo lo que no sea dígito y retorna Number. */
export function parseCLP(str) {
  const digits = String(str || "").replace(/\D+/g, "");
  return digits ? Number(digits) : 0;
}

/** Formatea etiquetas tipo "rca" → "RCA", "ambiental" → "Ambiental", "mesa_dialogo" → "Mesa diálogo". */
export function formatLabel(s) {
  if (!s) return "—";
  const v = String(s).trim();
  if (!v) return "—";
  if (v.toLowerCase() === "rca") return "RCA";
  const spaced = v.replace(/_/g, " ");
  return spaced.charAt(0).toUpperCase() + spaced.slice(1).toLowerCase();
}
